;(function () {
    let isHighContrastEnabled = () => window.localStorage.getItem('high-contrast') === 'true';
    var teaser = $('.ce_rsce_news_teaser');
    if (!teaser.length) {
        return;
    }

    // setup the homepage news teaser
    teaser.find('.inner').click(function () {
        if (isHighContrastEnabled()) return;
        const el = $(this).parent();
        if (el.hasClass('closed')) {
            el.removeClass('closed');
        } else {
            if (document.querySelector('body.neos-backend')) {
                return; // in the backend allow editing
            }

            el.addClass('closed');
        }
    });

    if (isHighContrastEnabled()) return;
    // hide the news teaser on the homepage after 4sec
    setTimeout(function () {
        if (document.querySelector('body.neos-backend')) {
            return; // in the backend allow editing
        }
        teaser.addClass('closed');
    }, 4000);

})();

;(function () {
    // homepage karo hover effect
    $('body.homepage .ce_rsce_triangle .inner')
        .hover(function () {
            $(this).parent().addClass('hover');
        }, function () {
            $(this).parent().removeClass('hover');
        })
        .on('touchstart', function () {
            // on mobile there is no hover, so make a click effect instead
            var body = $('body');
            if (body.hasClass('ios') || body.hasClass('android')) {
                $(this).parent().addClass('hover');
            }
        });
})();
